import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AutopayInstitution } from '@shared/services/autopay/types/getAutopayInstitutions.type';
import type { CardInstitution } from '@shared/services/autopay/types/getCardInstitutions.type';

import { initialState } from './initialState';
import type {
  AutopayCard,
  AutopayLimitsOption,
  AutopayPatientDetails,
  AutopayPatientTypeOptionsType,
  AutopayPayorDetails,
  AutopaySourceOptionsType,
  CardDetails,
} from '../types/autopay.types';

const autopaySlice = createSlice({
  initialState,
  name: 'Autopay',
  reducers: {
    clearAutopayLimitOption: (state) => {
      state.autopayLimitOption = initialState.autopayLimitOption;
    },
    clearAutopayPayorDetails: (state) => {
      state.autopayPayorDetails = initialState.autopayPayorDetails;
    },
    clearSelectedInstitution: (state) => {
      state.selectedInstitution = initialState.selectedInstitution;
    },
    clearSelectedPatient: (state) => {
      state.selectedPatient = initialState.selectedPatient;
    },
    deleteCard: (state, action: PayloadAction<{ Id: number }>) => {
      state.cardDetails = state.cardDetails.filter((card) => card.Id !== action.payload.Id);
    },
    setActiveCardDetails: (state, action: PayloadAction<AutopayCard>) => {
      state.activeCardDetails = action.payload;
    },
    setAutopayCard: (state, action: PayloadAction<AutopayCard[]>) => {
      state.autopayCards = action.payload;
    },
    setAutopayLimitOption: (state, action: PayloadAction<AutopayLimitsOption>) => {
      state.autopayLimitOption = action.payload;
    },
    setAutopayPatientType: (state, action: PayloadAction<AutopayPatientTypeOptionsType>) => {
      state.patientTypeOption = action.payload;
    },
    setAutopayPayorDetails: (state, action: PayloadAction<AutopayPayorDetails>) => {
      state.autopayPayorDetails = action.payload;
    },
    setAutopaySource: (state, action: PayloadAction<AutopaySourceOptionsType | null>) => {
      state.sourceOption = action.payload;
    },
    setCardDetails: (state, action: PayloadAction<CardDetails[]>) => {
      state.cardDetails = [...action.payload].sort((a, b) => Number(b.IsDefault) - Number(a.IsDefault));
    },
    setIsEditSummary: (state, action: PayloadAction<boolean>) => {
      state.isEditSummary = action.payload;
    },
    setSelectedCardId: (state, action: PayloadAction<null | number>) => {
      state.selectedCardId = action.payload;
    },
    setSelectedInstitution: (state, action: PayloadAction<AutopayInstitution | CardInstitution>) => {
      state.selectedInstitution = action.payload;
    },
    setSelectedPatient: (state, action: PayloadAction<AutopayPatientDetails>) => {
      state.selectedPatient = action.payload;
    },
  },
});

export const { actions: autopayAction } = autopaySlice;

export default autopaySlice.reducer;
